// extracted by mini-css-extract-plugin
export default {"title":"style_title__v9Dv3"};